module.exports = __webpack_public_path__ + "img/loginImg.6b01725a.svg";